import { lazy } from 'react'

export const AdaptationLibraryDrawer = lazy(() =>
  import('@app/modules/AdaptationLibrary/components/AdaptationLibrary.drawer').then((m) => ({
    default: m.AdaptationLibraryDrawer,
  })),
)

export const AdaptationLibraryPage = lazy(() =>
  import('@app/modules/AdaptationLibrary/pages/AdaptationLibrary.page').then((m) => ({
    default: m.AdaptationLibraryPage,
  })),
)

export const PrioritisationLandingPage = lazy(() =>
  import('@app/components/Risk/Prioritisation/PrioritisationLandingPage').then((m) => ({
    default: m.PrioritisationLandingPage,
  })),
)

export const RiskPage = lazy(() =>
  import('@app/routes/RiskPage/RiskPage').then((m) => ({ default: m.RiskPage })),
)

export const StoryBuilderContent = lazy(() =>
  import('@app/components/Risk/Story/Builder').then((m) => ({
    default: m.StoryBuilderContent,
  })),
)

export const StoryBuilderPanel = lazy(() =>
  import('@app/components/Risk/Story/Builder').then((m) => ({ default: m.StoryBuilderPanel })),
)

export const RiskStoryList = lazy(() => import('@app/components/Risk/Story/RiskStoryList'))

export const PrioritisationPage = lazy(() =>
  import('@app/routes/PrioritisationPage').then((m) => ({ default: m.PrioritisationPage })),
)

export const SummaryPage = lazy(() =>
  import('@app/routes/SummaryPage').then((m) => ({ default: m.SummaryPage })),
)

export const RiskProfilePage = lazy(
  () => import('@app/modules/Risk/Profile/pages/risk-profile.page'),
)

export const ProfileAnalysisPage = lazy(
  () => import('@app/modules/Risk/Profile/pages/profile-analysis.page'),
)

export const SelectedElementAnalysisPage = lazy(
  () => import('@app/modules/Risk/Profile/pages/selected-element.page'),
)

// Shared across two route trees: the public story view (RexRoutes.tsx) and
// the authenticated story view (this module's own route tree). Kept here,
// not duplicated, so both consumers import the same lazy-wrapped module —
// otherwise Rollup treats it as statically imported and cannot split it out
export const RiskStoryDetail = lazy(() =>
  import('@app/components/Risk/Story/RiskStoryDetail').then((m) => ({
    default: m.RiskStoryDetail,
  })),
)
